import * as React from 'react';
import { ComponentProps, WidgetProps } from '@intermix-dashboard/core';
import 'chartjs-plugin-streaming';
import { useThemeObserver } from '../hooks/useThemeObserver';
const Bubble = React.lazy(() =>
  import('react-chartjs-2').then((module) => ({ default: module.Bubble }))
);

export const IntermixStreamingBubbleChartComponent: React.FC<ComponentProps> = ({
  data,
  options,
}) => {
  const { display } = useThemeObserver();
  return (
    <React.Suspense fallback="loading...">
      {display && <Bubble data={data} options={options} />}
    </React.Suspense>
  );
};

export const IntermixStreamingBubbleChartWidget: WidgetProps = {
  id: 'bubble-stream-chart',
  name: 'Streaming Bubble Chart',
  component: IntermixStreamingBubbleChartComponent,
};
